import * as yup from 'yup';
import { ComparisonChart } from '@web/components';
import { schema as comparisonChartRow } from './comparison_chart_row';

export const component = ComparisonChart;

export const schema = yup
  .object({
    heading: yup.string().required(),
    description: yup.string(),
    textColor: yup.string(),
    backgroundColor: yup.string(),
    rows: yup.array(comparisonChartRow).required(),
    columns: yup.array().required(),
    level: yup.string(),
  })
  .transform(value => ({
    heading: value.heading,
    description: value.description,
    textColor: value.text_color || undefined,
    backgroundColor: value.background_color || undefined,
    rows: value.rows,
    columns: value.columns,
    level: value.level,
  }));
